//@flow
import React, { PureComponent } from 'react';

type Props = {
  entity: any,
  getFormContent: any,
  onSave: any,
  getForm: any,
  Componente: any,
  medico: any,
};
type State = {
  entity: any,
  edit: boolean,
};

class FolhaCard extends PureComponent<Props, State> {
  static defaultProps = {
    showEdit: true,
    canSave: true,
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      viewMode: props.viewMode,
    };
  }

  setEditMode = () => {
    this.setState({ viewMode: !this.state.viewMode }, () => {
      if (this.props.setEditMode) {
        this.props.setEditMode();
      }
    });
  };

  cancelForm = () => {
    this.setState({ viewMode: !this.state.viewMode }, () => {
      if (this.props.onCancel) {
        this.props.onCancel(this.state.edit);
      }
    });
    if (this.refComponent && this.refComponent.resetForm) {
      this.refComponent.resetForm(this.props.entity);
    }
  };
  saveForm = () => {
    if (this.refComponent) {
      this.refComponent.saveForm().then((result) => {

        if (result) {
          this.setEditMode();
          if (this.props.onSave) {
            this.props.onSave(result);
          }
        }
      });
    }
  };

  getBtns = () => {
    const { showEdit, canSave } = this.props;
    if (!this.state.viewMode && canSave) {
      return (
        <button
          onClick={this.saveForm}
          type="button"
          className="btn btn-primary"
        >
          Salvar
        </button>
      );
    } else if (this.state.viewMode && showEdit) {
      return (
        <button
          type="button"
          className="btn btn-link"
          onClick={this.setEditMode}
        >
          <span className="icon-btn-editar"></span>
          Editar
        </button>
      );
    }
  };

  render() {
    const { Componente, viewMode, showEdit, ...otherProps } = this.props;

    return (
      <div
        className={`folha-anamnese d-flex flex-column ${
          !this.state.viewMode ? 'viewMode' : 'noViewMode'
        } ${this.props.className ? this.props.className : ''}`}
      >
        <div className="folha-topo d-flex">
          <div className="titulo d-flex flex-fill align-items-center">
            <img className="folha-icon" src={this.props.icon} />
            {this.props.title}
          </div>
          {this.props.getBtns ? this.props.getBtns() : this.getBtns()}
        </div>
        <div className="folha-conteudo flex-fill">
          {Componente && (
            <Componente
              ref={(form) => {
                this.refComponent = form;
              }}
              viewMode={this.state.viewMode}
              {...otherProps}
            />
          )}
        </div>
      </div>
    );
  }
}
export default FolhaCard;
